import React from 'react'

export default ({ isActive, onClick, inputRef }) => {
  return (
    <div>
      <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" className="tooltip-icon">
        <g fill="none" fillRule="evenodd">
          <circle fill={isActive ? '#D8353B' : '#A5A8B0'} cx="11" cy="11" r="11" />
          <text fontFamily="Roboto-Regular, Roboto" fontSize="13" letterSpacing=".208" fill="#FFF">
            <tspan x="8" y="14">
              ?
            </tspan>
          </text>
        </g>
      </svg>
      <div
        style={{ position: 'absolute', width: '100%', height: '100%', top: 0 }}
        ref={inputRef}
        onClick={onClick}
      />
    </div>
  )
}
